import { render, staticRenderFns } from "./WeightManagement.vue?vue&type=template&id=f9ea1d7e&scoped=true&"
import script from "./WeightManagement.vue?vue&type=script&lang=ts&"
export * from "./WeightManagement.vue?vue&type=script&lang=ts&"
import style0 from "./WeightManagement.vue?vue&type=style&index=0&id=f9ea1d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ea1d7e",
  null
  
)

export default component.exports